import { createContext, useContext } from 'react';

export const BasePathContext = createContext<string>('/moment');

/** Base path the module is mounted under (e.g. `/moment`). Used to build absolute links. */
export function useBasePath(): string {
  return useContext(BasePathContext);
}

/** Returns a helper that prefixes module-relative paths with the base path. */
export function useHref(): (path: string) => string {
  const base = useBasePath();
  return (path: string) => `${base}${path.startsWith('/') ? path : `/${path}`}`.replace(/\/{2,}/g, '/');
}
